import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../common/components/Button';
import PostsSection from '../PostsSection';
import { StyledPagination } from './pagination.styled';

const Pagination = ({ posts, handlePagination, title, className, loading }) => (
  <StyledPagination className={className} isLoadMoreHidden={posts.length ? posts[0].amount == posts.length : true}>
    <PostsSection
      posts={posts}
      sectionTitle={title}
      postProps={{ direction: 'column' }}
    />
    <div className="pagination-button-wrapper">
      <Button
        handler={handlePagination}
        title="Load more news..."
        loading={loading}
      >
        Load more news...
      </Button>
    </div>
  </StyledPagination>
);

Pagination.propTypes = {
  posts: PropTypes.array.isRequired,
  handlePagination: PropTypes.func.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool
};

Pagination.defaultProps = {
  posts: [],
  handlePagination: () => console.log('Handler required')
};

export default Pagination;
